import React from "react";

const ContactSection = () => {
  return (
    <section className="section section-alt" id="contact">
      <div className="container contact-grid">
        <div className="section-copy">
          <p className="tag">Contact</p>
          <h2 className="section-title">
            Ready to talk about lighter chocolate lines.
          </h2>
          <p className="section-subtitle">
            Share a bit about your operation, and the Calowry team will follow
            up with technical information, application ideas and next steps.
          </p>

          <ul className="contact-points">
            <li>
              <span className="contact-label">Ideal partners</span>
              <span className="contact-body">
                Chocolate manufacturers, confectionery brands and food service
                producers.
              </span>
            </li>
            <li>
              <span className="contact-label">Location</span>
              <span className="contact-body">
                Operations based around the world, serving global
                partners.
              </span>
            </li>
          </ul>
        </div>

        <div className="contact-card">
          <h3>Send a note</h3>
          <p>
            Use your preferred email client to outline your needs, capacity and
            timelines. Calowry will respond directly.
          </p>
          <a
            href="mailto:info@calowrychocolate.com"
            className="btn primary-btn contact-btn"
          >
            Email the team
          </a>
          
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
